module.exports = __webpack_public_path__ + "img/HA2507-83.1635c9ab.jpg";